const title = {
  fontSize: '24px',
  lineHeight: '30px',
  fontWeight: '400',
  textTransform: 'none',
  'screen-medium': {
    fontSize: '32px',
    lineHeight: '40px',
  }
}

const loyaltyProductsGrid = {
  title
}

export default loyaltyProductsGrid
